import { useEffect, useState } from 'react';

/**
 * Hook para detectar si estamos en un dispositivo de escritorio
 * Basado en el breakpoint lg (1024px) de Tailwind
 * @returns {boolean} true si es escritorio (>= 1024px), false si es móvil/tablet
 */
export const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    // Función para verificar si es escritorio
    const checkIsDesktop = () => {
      setIsDesktop(window.innerWidth >= 1024); // lg breakpoint
    };

    // Verificar inicialmente
    checkIsDesktop();

    // Agregar listener para cambios de tamaño
    window.addEventListener('resize', checkIsDesktop);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIsDesktop);
    };
  }, []);

  return isDesktop;
};
